import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";


class SubItem3 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item3">
                <Row style={{backgroundColor: "fff", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={4}>
                        
                    </Col>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Perfil del egresado</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El Diseñador de Interior formado en nuestra institución es un profesional con competencias para desarrollar proyectos de diseño interior a partir de un criterio funcional, tecnológico y ético en la elección e implementación de materiales, técnicas, sistemas e instalaciones.  Diseña y construye espacios y equipamientos, y adapta los existentes a nuevas necesidades funcionales y estéticas, logrando una mejor identidad de los usuarios con los espacios y objetos que construyen su entorno cotidiano. 
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem3;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoInterior/SubItem3.jsx